export const featureManagerConstants = {
    "FREE_TRIAL_POPOVER": "FREE_TRIAL_POPOVER",
    "PAY_POPOVER": "PAY_POPOVER",
};